import {dt} from "@/i18n";

export function dateFormat(value:string, format = null) {
    if(!format) {
        return dt(value).format('L LT');
    }

    if(format === 'fromNow') {
        return dt(value).fromNow();
    }

    return dt(value).format(format);
}